import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { ModalService } from '@shared/services/modal/modal.service';
import { combineLatest, map, Observable, first, filter, switchMap } from 'rxjs';
import { ItemRepositoryService } from '../../services/item-repository.service';
import { Price } from './enums/price';
import { AddCartItemService } from 'src/app/shared/modules/add-cart-item/services/add-cart-item.service';
import { Discount } from '../../../lab-pass/constants/discount.constants';
import { ServiceInDiagnosticCenterComponent } from '../service-in-diagnostic-center/service-in-diagnostic-center.component';
import { HelixRoutes } from '@shared/enums/routes';
import {
  AppointmentServiceType,
  NomenclatureResponse,
  PreorderAvailabilityStatus,
} from '@medindex-webapi';
import { YmGoalCatalogItem } from '../../enums/ym-goal-catalog-item.enum';

@Component({
  selector: 'app-catalog-item-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceComponent {
  constructor(
    public repository: ItemRepositoryService,
    private modalService: ModalService,
    private addCartItemService: AddCartItemService
  ) {}

  @Output() scrollTo = new EventEmitter();

  readonly Discount = Discount;
  readonly PreorderAvailability = PreorderAvailabilityStatus;
  readonly HelixRoutes = HelixRoutes;

  showBiomaterialServices$: Observable<boolean> = combineLatest([
    this.repository.appointmentType$,
    this.repository.nomenclature$,
  ]).pipe(
    map(([appointmentType, nomenclature]) => {
      return (
        (appointmentType !== AppointmentServiceType.Vaccination &&
          nomenclature !== null &&
          nomenclature.companionBiomaterialServices &&
          nomenclature.companionBiomaterialServices.length > 0) ??
        false
      );
    })
  );

  currency$: Observable<string> = this.repository.nomenclature$.pipe(
    map((nomenclature) => nomenclature?.currency?.symbol ?? '')
  );

  priceTitle$: Observable<string> = this.repository.nomenclature$.pipe(
    map((nomenclature) => {
      if (!nomenclature) return '';

      const price = `${nomenclature.servicePricesInfo?.minimalServicesCost} ${nomenclature.currency?.symbol}`;
      const priceFrom = Price.From + ' ' + price;

      if (nomenclature.servicePricesInfo?.canCostBeHigher) return priceFrom;

      return price;
    })
  );

  orderAvailable(): void {
    this.repository.appointmentType$
      .pipe(
        filter(
          (appointmentType) =>
            appointmentType === AppointmentServiceType.Default ||
            appointmentType === AppointmentServiceType.Covid
        ),
        switchMap(() => this.repository.nomenclature$),
        first(),
        filter(
          (nomenclature): nomenclature is NomenclatureResponse => !!nomenclature
        ),
        switchMap((nomenclature) =>
          this.addCartItemService.addItemWithConfirmation(
            nomenclature.hxid ?? '',
            YmGoalCatalogItem.ItemAddToCart
          )
        ),
        first()
      )
      .subscribe();
  }

  orderOnlyInDiagnosticCenter(): void {
    this.modalService.create({
      nzContent: ServiceInDiagnosticCenterComponent,
      nzClassName: 'service-in-diagnostic-center',
      nzStyle: { padding: 0 },
      nzClosable: false,
      nzAutofocus: null,
      nzFooter: null,
    });
  }
}
